var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopup3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFE4E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18359 5.84961C10.1859 5.84961 11.1912 6.18033 12.001 6.83594C12.8101 6.18102 13.8135 5.85359 14.8164 5.85352H14.8174C15.9235 5.85352 17.0321 6.25047 17.8779 7.04785C19.5741 8.64606 19.5741 11.2416 17.8779 12.8398L17.71 12.9971L12.4131 17.9883C12.3021 18.0931 12.1532 18.1504 12 18.1504C11.8474 18.1503 11.6991 18.0942 11.5879 17.9893L6.29102 12.998L6.12207 12.8398C4.42566 11.2417 4.42567 8.6461 6.12207 7.04785C6.96816 6.25026 8.07782 5.84967 9.18359 5.84961ZM14.8174 6.96582C14.0599 6.96582 13.3029 7.22341 12.6992 7.73828L12.5811 7.84473L12.4141 8.00293C12.3033 8.10744 12.1543 8.164 12.001 8.16406C11.8854 8.16406 11.7725 8.13178 11.6768 8.07129L11.5879 8.00195L11.4199 7.84473C10.799 7.25952 9.99369 6.9707 9.18359 6.9707C8.37359 6.97073 7.56918 7.25952 6.94824 7.84473C5.71075 9.01102 5.70944 10.8716 6.94434 12.0391L6.94824 12.042L7.1123 12.1963H7.11328L12 16.8018L16.8848 12.1973L16.9375 12.1475H16.9404L17.0527 12.043C18.2914 10.8755 18.2915 9.01217 17.0527 7.84473C16.4308 7.25921 15.625 6.96585 14.8174 6.96582Z",
    fill: "#FB839F",
    stroke: "#FB839F",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup3);
export default __webpack_public_path__ + "static/media/popup3.f52d8429c094d57bf5ab6ebdc1fde9d7.svg";
export { ForwardRef as ReactComponent };